interface AppButtonProp {
  name: string;
  icon: JSX.Element;
  url: string;
  color?: string;
  disabled?: boolean;
};

export function AppButton( { name, icon, url, disabled }: AppButtonProp ) {

  const baseClass = 'flex flex-col justify-center items-center m-4 p-4 min-w-[250px] shadow-md shadow-gray-400 rounded-lg bg-gray-200';
  const disabledClass = 'pointer-events-none opacity-50 cursor-not-allowed';

  return (
    <a
      className={ `${baseClass} ${disabled ? disabledClass : 'hover:scale-105 cursor-pointer'}` }
      href={ disabled ? undefined : url }
      aria-disabled={ disabled }
      onClick={ disabled ? e => { e.preventDefault(); } : undefined }
      role="button"
    >
      <div className="m-2">{ icon }</div>
      <div className="font-bold text-gray-600">{ name }</div>
    </a>
  );
}